import { LogoParams } from '@models/logo-params';

export namespace LogoHelpers {
    export function setLogoParams(isZB: boolean): LogoParams {
      if (isZB) {
        return {
          logoId: 'zbLogo',
          logoUrl: 'assets/zbportal/img/zb-logo.svg',
          logoAltText: 'ZB Portal logo return to Overview'
        };
      }
      return {
        logoId: 'highlightsLogo',
        logoUrl: 'assets/img/highlights-logo.svg',
        logoAltText: 'Highlights Portal'
      };

    }
}
